import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import CamposBusqueda from '../../components/listados/CamposBusqueda'
import CargaDiariaView from '../../components/listados/controlDiario/CargaDiariaView'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { formValueSelector, reduxForm } from 'redux-form'
import { actualizarDatosTablaCargaDiaria } from '../../actions/controlDiario'
import { parseEntityId } from '../../../../models/entity'
import { FORM_RESUMEN_CARGA } from '../../../../config/forms'

function ControlCargaDiario (props) {
  const { change: formChange, actualizarDatosTablaCargaDiaria } = props

  useEffect(() => {
    actualizarDatosTablaCargaDiaria(new Date(), new Date())
  }, [actualizarDatosTablaCargaDiaria])

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  const handleSubmit = () => {
    const { fechaDesde, fechaHasta, exportadorCarga, cerealCarga } = props
    const exportador = parseEntityId(exportadorCarga) || null
    const cereal = (cerealCarga && (cerealCarga.trim() !== 'UNDEF') && cerealCarga.trim()) || null
    actualizarDatosTablaCargaDiaria(fechaDesde, fechaHasta, exportador, cereal)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <CamposBusqueda actualizarFechas={actualizarFechas} handleSubmit={handleSubmit} />
      <CargaDiariaView />
    </>
  )
}

const selector = formValueSelector(FORM_RESUMEN_CARGA)

const mapStateToProps = (state) => ({
  exportadorCarga: selector(state, 'exportador'),
  cerealCarga: selector(state, 'cereal'),
  fechaDesde: selector(state, 'fechaDesde'),
  fechaHasta: selector(state, 'fechaHasta')
})

const mapActionsToProps = {
  actualizarDatosTablaCargaDiaria
}

const withReduxForm = reduxForm({
  form: FORM_RESUMEN_CARGA
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(ControlCargaDiario))
